import { FC, useCallback } from 'react';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import CustomTextArea from '~src/shared/form/inputs/CustomTextArea';
import TitleInput from '~src/shared/form/inputs/TitleInput';
import { FieldType } from '~src/types';
import { validatorMaxLength1000, validatorRequired } from '~src/services/validators';
import SelectorHandler from '~src/modules/okrs/manageObjectives/shared/SelectorHandler';
import useFocusFirstInput from '~src/services/hooks/useFocusFirstInput';
import { InfoContainer } from '~src/modules/okrs/manageObjectives/shared/shared.sc';

const ObjectiveInfo: FC = () => {
  const [t] = useTranslation();

  const { inputRef } = useFocusFirstInput();

  const renderTitle = useCallback(
    ({ input, label, meta: { touched, error } }: FieldType) => (
      <SelectorHandler hoverTextKey="x.objective.add.icon.title" iconName="iconTarget">
        {(isSelected, select, blur) => (
          <div data-translation={label}>
            <TitleInput
              {...input}
              inputRef={inputRef}
              error={touched ? error : undefined}
              placeholder={t(label)}
              onSelect={select}
              onBlur={blur}
              isSelected={isSelected}
            />
          </div>
        )}
      </SelectorHandler>
    ),
    [],
  );

  const renderDescription = useCallback(
    ({ input, label, meta: { touched, error } }: FieldType) => (
      <SelectorHandler hoverTextKey="x.objective.add.icon.description" iconName="iconBars">
        {(_, select, blur) => (
          <div data-translation={label}>
            <CustomTextArea
              {...input}
              error={touched ? (error as string) : undefined}
              label={t(label)}
              labelKey={label}
              onFocus={select}
              onBlur={blur}
            />
          </div>
        )}
      </SelectorHandler>
    ),
    [],
  );

  return (
    <InfoContainer>
      <Field
        name="title"
        label="x.okr.objective.form.title.placeholder"
        component={renderTitle}
        validate={validatorRequired}
      />
      <Field
        name="description"
        label="x.okr.objective.form.description.placeholder"
        component={renderDescription}
        validate={validatorMaxLength1000}
      />
    </InfoContainer>
  );
};

export default ObjectiveInfo;
